import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const AddNote = styled(IconButton)`
  position: relative;
  top: 0;
  right: 0;
`;
